const $ = window.jQuery;

class DigitalResources {
  constructor() {
    this.toggle();
  }

  toggle() {
    const $bar = $(".digital-resources");
    if (!$bar.length) return;

    const $title = $(".digital-resources__title");
    const $links = $(".digital-resources__links");
    $links.hide().css("opacity", 0);

    $title.on("click", function (event) {
      event.preventDefault();

      if (!$bar.hasClass("digital-resources--open")) {
        $bar.addClass("digital-resources--open");
        $links.slideDown(500).animate({ opacity: 1 }, { queue: false, duration: 500 });
      } else {
        $bar.removeClass("digital-resources--open");
        $links.slideUp(500).animate({ opacity: 0 }, { queue: false, duration: 500 });
      }
    });
  }
}

export default DigitalResources;
